import React, { useState, useEffect } from "react";
import { motion } from "framer-motion/dist/framer-motion";
import _ from "lodash";

import {
  divVariants,
  logoVariants,
  fadeVariants,
  bounceRightVariants,
  heartBeatVariants,
} from "../../shared/utils/animations";
import Socket from "../../../socket/socket";
import ttlLogo from "../../../assets/images/ttl/ttl-logo.png";
import checkmark from "../../../assets/images/ttl/green-mark.png";

const ChooseAskerTTL = ({
  users,
  roomId,
  game_state,
  ttl_chooseasker_params,
}) => {
  const { player_scores, submissions = [] } = game_state;
  const [usersArray, setUsersArray] = useState([]);
  const [liar, setLiar] = useState(null);
  const [autoPick, setAutoPick] = useState(false);

  const primary_text = _.get(
    ttl_chooseasker_params,
    "primary_text",
    "Whose statements to use?",
  );
  const secondary_text = _.get(
    ttl_chooseasker_params,
    "secondary_text",
    "Click on the name of The Player.",
  );
  const button_text = _.get(
    ttl_chooseasker_params,
    "button_text",
    "Choose Player",
  );
  const how_to_play = _.get(
    ttl_chooseasker_params,
    "how_to_play",
    "How to Play",
  );
  const text_1 = _.get(
    ttl_chooseasker_params,
    "text_1",
    "Players can submit their Two Truths and a Lie on their mobile device. Once completed, the Host can choose the Player for the round.",
  );
  const text_2 = _.get(
    ttl_chooseasker_params,
    "text_2",
    "The other players then try to guess The Lie.",
  );
  const player_text = _.get(
    ttl_chooseasker_params,
    "player_text",
    "For The Player:",
  );
  const guesser_text = _.get(
    ttl_chooseasker_params,
    "guesser_text",
    "For the Guessers:",
  );
  const points_100 = _.get(ttl_chooseasker_params, "points_100", "+100 Points");
  const points_200 = _.get(ttl_chooseasker_params, "points_200", "+200 Points");
  const points_300 = _.get(ttl_chooseasker_params, "points_300", "+300 Points");
  const point_100_text = _.get(
    ttl_chooseasker_params,
    "point_100_text",
    "to Guessers that correctly guess the Lie.",
  );
  const point_200_text = _.get(
    ttl_chooseasker_params,
    "point_200_text",
    "if they fool half or more of the Guessers.",
  );
  const point_300_text = _.get(
    ttl_chooseasker_params,
    "point_300_text",
    "if they fool all of the Guessers.",
  );

  useEffect(() => {
    let array = [...usersArray];
    let scores_array = [...player_scores];
    for (let i = array.length; i < users.length; i++) {
      array = [
        ...array,
        {
          ...scores_array[i],
          display_name: users[i].display_name,
          profile_image: users[i].profile_image,
        },
      ];
    }
    if (submissions.length !== 0) {
      for (let i = 0; i < submissions.length; i++) {
        array = [
          ...array.map((user) => {
            if (submissions[i].player_id === user.player_id) {
              return { ...user, submitted: true };
            } else {
              return user;
            }
          }),
        ];
      }
    }
    setUsersArray(array);
  }, [player_scores, submissions]);

  const handleUserClick = (player) => {
    if (player.submitted) {
      let array = [
        ...usersArray.map((user) => {
          if (user.player_id === player.player_id) {
            return { ...user, selected: true };
          } else {
            return { ...user, selected: false };
          }
        }),
      ];
      setLiar(player.player_id);
      setUsersArray(array);
    }
  };

  const handleChooseLiar = () => {
    if (liar !== null) {
      let data = {
        action: "update-status",
        roomId,
        asker: liar,
      };
      Socket.sendMessage(data);
    }
  };

  const handlePickForUs = () => {
    if (!autoPick && !_.isEmpty(submissions)) {
      setAutoPick(true);
      let arr = [...usersArray];
      let min_turns = 0;
      arr = arr.map((item) => {
        item.turns > min_turns && (min_turns = item.turns);
        return { ...item, selected: false };
      });
      setUsersArray([...arr]);
      let selected_player_id;
      for (const user of arr.reverse()) {
        if (user.submitted) {
          if (user.turns <= min_turns) {
            selected_player_id = user.player_id;
            min_turns = user.turns;
          }
        }
      }
      for (const user of arr) {
        user.player_id === selected_player_id && (user.selected = true);
      }
      setLiar(selected_player_id);
    } else {
      setAutoPick(false);
    }
  };

  useEffect(() => {
    if (liar !== null && autoPick) {
      setTimeout(() => {
        handleChooseLiar();
      }, 300);
    }
  }, [liar, autoPick]);

  const staticBounceVariants = {
    hidden: { scale: 0 },
    visible: {
      scale: [0.3, 1.15, 0.85, 1.1, 0.95],
      transition: { duration: 0.7 },
    },
    exit: {
      scale: [0.95, 0.85, 1.1, 0.2],
    },
  };

  return (
    <>
      <motion.section
        variants={divVariants}
        initial="hidden"
        animate="visible"
        exit="exit"
        className="ttl-users-wrapper"
      >
        <motion.img
          variants={logoVariants}
          src={ttlLogo}
          className="ttl-logo"
          alt="ttlLogo"
        />
        <motion.h2 variants={fadeVariants} className="title">
          {primary_text}
        </motion.h2>
        <motion.div variants={fadeVariants}>
          <motion.p variants={heartBeatVariants} className="info">
            {secondary_text}
          </motion.p>
        </motion.div>
        <motion.div
          variants={fadeVariants}
          className="ttl-users-list"
          style={{ display: users.length === 0 ? "none" : "block" }}
        >
          <div className="ttl-users-flex">
            {usersArray.length !== 0 &&
              usersArray.map((user, index) => (
                <motion.div
                  key={index}
                  variants={staticBounceVariants}
                  onClick={() => (!autoPick ? handleUserClick(user) : {})}
                  className={`ttl-user ${user.submitted ? "active" : ""} ${
                    user.selected ? "active2" : ""
                  }`}
                >
                  <div className="d-flex align-items-center">
                    <img
                      src={user.profile_image}
                      className="ttl-user-img"
                      alt="ttlUserImg"
                    />
                    <p className="username mb-0">{user.display_name}</p>
                  </div>
                  <p className="mb-0 points">{user.score}</p>
                </motion.div>
              ))}
          </div>
        </motion.div>
        <div className="chooseasker-btn">
          <motion.button
            variants={staticBounceVariants}
            onClick={handleChooseLiar}
            className="ttl-button"
          >
            {button_text}
          </motion.button>
          <motion.div
            variants={staticBounceVariants}
            className={`pick-for-us ${autoPick ? "selected" : ""}`}
            onClick={handlePickForUs}
          >
            <div className={`checkbox ${autoPick ? "selected" : ""}`}>
              {autoPick && <img alt="" src={checkmark} />}
            </div>
            Pick For Us
          </motion.div>
        </div>
      </motion.section>
      <motion.div
        variants={bounceRightVariants}
        initial="hidden"
        animate="visible"
        exit="exit"
        className="ttl-how-to-play"
      >
        <h2 className="how-title">{how_to_play}</h2>
        <p className="text">{text_1}</p>
        <p className="text">{text_2}</p>
        <p className="role-text">{player_text}</p>
        <ul>
          <li>
            <span>{points_200}</span> {point_200_text}
          </li>
          <li>
            <span>{points_300} </span>
            {point_300_text}
          </li>
        </ul>
        <p className="role-text-guesser">{guesser_text}</p>
        <ul>
          <li>
            <span>{points_100} </span>
            {point_100_text}
          </li>
        </ul>
      </motion.div>
    </>
  );
};

export default ChooseAskerTTL;
